import { Component, OnInit } from '@angular/core';
import { ProductInstanceModel } from '@shared/models/data/product-instance-model';
import { SeatAssignmentModel } from '@shared/models/data/seat-assignment-model';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { SeatAssignmentService } from '@shared/services/seat-assignment.service';
import { SessionService } from '@shared/services/session.service';
import { UserProfileService } from '@shared/services/user-profile.service';

@Component({
  selector: 'aaos-app-oite-page',
  templateUrl: './oite-page.component.html',
  styleUrls: ['./oite-page.component.scss']
})
export class OitePageComponent implements OnInit {

  constructor(
    private enrollmentService: EnrollmentService,
    private seatAssignmentService: SeatAssignmentService,
    private sessionService: SessionService,
    private userProfileService: UserProfileService) {
  }

  residents: SeatAssignmentModel[];
  oiteProduct: ProductInstanceModel;
  paidResidents;
  unpaidResidents;
  loading = true;
  institutionId: string;
  productId: string;

  ngOnInit() {
    this.oiteProduct = new ProductInstanceModel();
    this.institutionId = this.sessionService.getInstitutionId();
    this.getResidents();
  }

  getResidents() {
    this.enrollmentService.getOverViewModel(this.institutionId).subscribe(overviewModel => {
      this.productId = this.userProfileService.getOiteProduct(overviewModel).id;
      this.enrollmentService.getProductInstance(this.institutionId, this.productId).subscribe(oiteProduct => {
        this.residents = oiteProduct.seatAssignments;
        this.oiteProduct = oiteProduct;
        this.paidResidents = this.seatAssignmentService.getPaidSeats(this.residents);
        this.unpaidResidents = this.seatAssignmentService.getWishList(this.residents);
        this.loading = false;
      });
    });


  }





}
